/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Hero_H1_EmInputs */

const es_cap_hero_h1_em = /** @type {(inputs: Cap_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu manera.`)
};

const gl_cap_hero_h1_em = /** @type {(inputs: Cap_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`teu modo.`)
};

const en_cap_hero_h1_em = /** @type {(inputs: Cap_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your way.`)
};

/**
* | output |
* | --- |
* | "your way." |
*
* @param {Cap_Hero_H1_EmInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_hero_h1_em = /** @type {((inputs?: Cap_Hero_H1_EmInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Hero_H1_EmInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_hero_h1_em(inputs)
	if (locale === "en") return en_cap_hero_h1_em(inputs)
	return es_cap_hero_h1_em(inputs)
});